import { UserType } from 'v2/core/entities/user';
import { UserRowRoleType } from '../store/types';

export const mapUserTypeToUserRowRoleType = (
  userType: UserType | undefined,
): UserRowRoleType | null => {
  switch (userType) {
    case UserType.Manager:
      return UserRowRoleType.Admin;
    case UserType.Editor:
      return UserRowRoleType.Editor;
    case UserType.Member:
      return UserRowRoleType.Member;
    case UserType.Viewer:
      return UserRowRoleType.Viewer;
    case UserType.SuperManager:
      return UserRowRoleType.SuperAdmin;
    case UserType.SuperEditor:
      return UserRowRoleType.SuperEditor;
    case UserType.SuperMember:
      return UserRowRoleType.SuperMember;
    case UserType.SuperViewer:
      return UserRowRoleType.SuperViewer;
    default:
      return null;
  }
};
